import createModelStore from "../../utils/createModelStore";
import CarClass from "../../services/CarClass";

/** @deprecated */
const carClasses = createModelStore<CarClass.Model, "carClasses">("carClasses");

export default carClasses;
